module.exports = __webpack_public_path__ + "img/owl.d2a5b013.png";